<template>
  <div>
    <div class="header">
      <div class="header_content">
        <div v-if="!hasToken" @click="toLogin('/Register')">{{$t("auth.register")}}</div>
        <div v-else></div>
        <div class="img">
          <img src="/img/homenavlogo.png" alt="" />
        </div>
        <div style="display: flex; align-items: center;" v-if="!hasToken" @click="toLogin('/Login')">
          <van-icon name="chat-o" color="#fff" size="24" />
          {{$t("auth.login")}}
        </div>
        <div v-else @click="toLogin('/ServiceOnline')">
          <van-icon name="chat-o" color="#fff" size="24" />
        </div>
      </div>
    </div>

    <div style="height: 160px;">
      <swiper class="banner_swiper" :options="bannerSwiperOption" v-if="banners.length > 0">
        <swiper-slide v-for="(v, key) in banners" :key="key">
          <van-image
            class="banner_img"
            :src="getBannerUrl(v)"
            width="100%"
            height="160px"
            fit="cover"
          >
            <template v-slot:loading>
              <van-loading type="circular" />
            </template>
          </van-image>
        </swiper-slide>
      </swiper>
      <div v-else style="height: 160px; background: #eee; display: flex; align-items: center; justify-content: center;">
         <van-loading type="circular" />
      </div>
    </div>

    <div style="padding: 8px; background: rgb(243, 243, 245);">
      <van-notice-bar
        class="notice-swiper"
        color="rgb(62, 30, 136)"
        background="#fff"
        scrollable
        :text="notice"
      >
        <template #left-icon>
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAkCAYAAAD2IghRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC60lEQVRYhdXYXahUVRQH8N/dXft4CBLKS4QgPWReEx81UXtIoxAiKTJIMX0tjdCLkGZZBCqXKIIgEgtKCQIhiqLSlz6M9CEI4oaUglIvUSiIqNQ5Paw5cBzHO2fmnmnm/mGYs9dea+//2WfvtdZeQ2Prf5XkhvKs8Z9LMinPDcmlPJ6T7Iq+1NCP/queZ6U8G0t5tirJ85Rnh1KevdBavxizmLMsC53gUeaQG1Y/nsEruKUkG8W9WFHXJKmugbAY3+BNV5IucL+pEV+G24tGHcRvxhv4Hkvb6I52Mf5KHMXX+BkLmTrxtZjA5or6/3Qw9nx8hC/FNoOZ4kW63uNLsR0PdmiXVdC5DTu0XozDeJ/WxEdxD0aQN37/4ibMxhIs6pBwFQxjK7a5+oycwIv4sKxcYCHG1XjyO8B67MSdTfLzeBV7NX2tgvgKfNVrdtfAOLa0kL8lSP/RymhYeIXPe8erLR5van+MXfhxMqMkDkEvAlFVPIqf8AMexiPakCYIP9RTWu1xXMM3d4KE6+vn0nsk4eqmHZLw09MOdSZZ/yv66U3K2IgFFXUvYN8gEH8Wr3dos3EQtsqtXdiMDMKK7xFnrcjVJ8sgZ+Ac3h4E4udFitwRBmGrdIVpTfy6fpPoBgmX+k2iGySc6jOHO0QOfkiUOCoh4WCvGFXEeyIPXy1KHPsxp51Rwhf4pIfE2uFEU3uDKHm8hBuuZVR4lcdEFaofeBpj+Ksku1Hc6n/BU62MCuKXsVy85e+9YjgJxnEXXmuSz8G7+A4PlDuaI+cu7BYFn9nizYsQnIkXHcFcPKFeV/q3uO3vE6u9ptS3RGzpA+ILnWsV8i/hSIWJduI5UZ2tiqEKOhNiUd5pzLG81PckTuP5qUTOk9gkqlqHK9p0cr89gvsE2YmS/Cj1hPxjohC5TvuYcKaL8Q+KzHGtKDV/Sr25yge4Gy9rfQH/DZ9NYfwD+LZo1J1kXRYHa15jorP4U6zaMlysa6L/AAjlvYZkAVJOAAAAAElFTkSuQmCC"
            alt="Custom Icon"
            style="width: 15px; height: 15px; margin-right: 10px;"
          />
        </template>
      </van-notice-bar>
    </div>

    <div>
      <div style="margin: 10px;">
        <span style="font-size: 16px;">{{$t("index.Highend_area")}}</span>
        <span class="sub">{{$t("index.extreme")}}</span>
      </div>

      <div
        style="
          display: flex;
          width: 100%;
          overflow-y: auto;
          flex-wrap: nowrap;
          padding: 10px;
        "
      >
        <div
          class="gdgride"
          style="margin-right: 5px;"
          v-for="(group, index) in groupedData"
          :key="index"
        >
          <div v-for="item in group" :key="item.id">
            <div
              @click="toDetail(item.id)"
              class="van-image"
              style="
                width: 100px;
                height: 100px;
                overflow: hidden;
                border-radius: 8px;
              "
            >
              <img
                :src="fixHttpUrl(item.img_url)"
                class="van-image__img"
                style="object-fit: cover;"
              />
            </div>
            <div
              style="
                position: absolute;
                bottom: 10px;
                text-align: center;
                color: rgb(255, 255, 255);
                width: 100%;
                font-size: 12px;
              "
            >
              {{ item.xuanfei_name }}
            </div>
          </div>
        </div>

        <div
          @click="toLogin('/Choose')"
          style="
            width: 23px;
            padding: 20px 5px 10px;
            height: 145px;
            margin-top: 30px;
            background: rgb(249, 249, 249);
            color: rgb(153, 153, 153);
            font-size: 12px;
          "
        >
          {{$t("concubine.ckgdsj")}}
        </div>
      </div>
    </div>

    <div class="online-match-box">
      <div class="online-match-title">
<span class="online-dot"></span>
Members Online:{{ onlineCount.toLocaleString() }}
      </div>

      <div class="OnlineMatching">
        <div
          class="online-scroll"
          :style="{ transform: `translateY(${onlineTranslateY}px)` }"
        >
          <div class="online-row" v-for="(item, index) in displayRollingList" :key="'a' + index">
            <div class="online-avatar-wrap">
              <img :src="item.avatar" class="online-avatar" />
              <span class="online-badge">Verified</span>
            </div>
            <div class="online-inline">
              <span class="online-name">{{ item.name }}</span>
              <span class="online-meta">{{ item.age }} ・ {{ item.city }}</span>
              <span class="online-status">Dating Service</span>
            </div>
            <span class="online-live">Online</span>
          </div>

          <div class="online-row" v-for="(item, index) in displayRollingList" :key="'b' + index">
            <div class="online-avatar-wrap">
              <img :src="item.avatar" class="online-avatar" />
              <span class="online-badge">Verified</span>
            </div>
            <div class="online-inline">
              <span class="online-name">{{ item.name }}</span>
              <span class="online-meta">{{ item.age }}|・{{ item.city }}</span>
              <span class="online-status">Dating Service</span>
            </div>
            <span class="online-live">LIVE</span>
          </div>
        </div>
      </div>
    </div>

    <div style="padding: 10px;">
      <div style="font-size: 16px;">{{$t("index.recommend")}}</div>
      <div>
        <div class="horizontalItem" v-for="item in datalist" :key="item.id" @click="toDetail(item.id)">
          <div class="imgBox">
            <div
              class="van-image"
              style="
                width: 120px;
                height: 120px;
                overflow: hidden;
                border-radius: 8px;
              "
            >
              <img
                :src="fixHttpUrl(item.img_url)"
                class="van-image__img"
                style="object-fit: cover;"
              />
            </div>
          </div>

          <div style="width: calc(100% - 140px);">
            <div class="top">
              <div>
                <div class="van-image" style="width: 13px;">
                  <img
                    src="/img/vip.png"
                    style="width: 13px; height: 13px;"
                    class="van-image__img"
                  />
                </div>
                <span>{{$t("index.authentication")}}</span>
              </div>
              <div>
                <div class="van-image" style="width: 13px;">
                  <img
                    src="/img/vip.png"
                    class="van-image__img"
                    style="width: 13px; height: 13px;"
                  />
                </div>
                <span>{{$t("index.video_authentication")}}</span>
              </div>
              <div
                style="
                  width: 70px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                "
              >
                {{ item.xuanfei_name }}
              </div>
            </div>

            <div class="tags">
              <van-tag
                v-for="(tag, index) in item.flagArray"
                :key="index"
                :type="tagTypes[index]"
              >
                {{ tag }}
              </van-tag>
            </div>

            <div style="display: flex; align-items: center;">
              <span style="font-size: 14px; color: rgb(102, 102, 102);">
                {{$t("index.toll")}}：
              </span>
              <van-rate v-model="item.number" color="#ffd21e" size="20px" />
            </div>

            <div
              style="
                color: rgb(153, 153, 153);
                font-size: 12px;
                margin: 5px 0px;
              "
            >
              {{$t("index.height")}}: {{item.hight}}cm {{$t("index.bust")}}：{{ item.bust }} {{$t("index.address")}}： {{$t("index.National")}}：{{$t("index.yes")}}
            </div>

            <div class="yueta">{{$t("index.about")}}</div>
          </div>
        </div>
      </div>
    </div>

    <div style="padding-bottom: 55px;"></div>
  </div>
</template>

<script>
// 1. 顶部导入 JSON 数据
import poolData from '@/data/pool.json';

export default {
  data() {
    return {
      // 3. 其他原有数据
      notice: this.$t("index.loading"),
      hasToken: false,
      basicData: [],
      datalist: [],
      groupedData: [],
      banners: [],
      onlineCount: 0,
      onlineTranslateY: 0,
      scrollTimer: null,
      displayRollingList: [],
      avatarPool: Array.from({ length: 60 }, (_, i) => `/img/avatar/avatar${i + 1}.png`),
      
      bannerSwiperOption: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        speed: 800,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        observer: true,
        observeParents: true,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true
        }
      },
      tagTypes: ["primary", "success", "danger", "warning"]
    };
  },
  watch: {
    // 监听语言变化，重新加载配置
    '$i18n.locale'() {
       this.getBasicConfig();
    }
  },
  methods: {
    fixHttpUrl(url) {
      if (!url) return "";

      // 1. 彻底修复：修正不规范的路径 admin/pairsvip.com -> admin.pairsvip.com
      let fixedUrl = url.replace(/admin\/pairsvip\.com/g, 'admin.pairsvip.com');

      // 2. 强制将 http:// 替换为 https://
      if (fixedUrl.startsWith("http://")) {
        fixedUrl = fixedUrl.replace("http://", "https://");
      }

      // 3. 处理没有协议头但包含域名的情况
      if (fixedUrl.includes("admin.pairsvip.com") && !fixedUrl.startsWith("http")) {
        fixedUrl = "https://" + fixedUrl;
      }

      // 4. 处理纯相对路径情况
      if (!fixedUrl.startsWith("http") && !fixedUrl.includes("pairsvip.com")) {
          fixedUrl = "https://admin.pairsvip.com/" + fixedUrl.replace(/^\/+/, "");
      }

      // 5. 最终清理重复斜杠 (排除 https://)
      return fixedUrl.replace(/([^:])\/{2,}/g, "$1/");
    },
    getBannerUrl(banner) {
      let url = typeof banner === "string"
        ? banner
        : (banner && (banner.url || banner.img_url || banner.image || banner.pic)) || "";

      if (!url) return "";

      return this.fixHttpUrl(url);
    },
    getNoticeText(data) {
      if (!data || !data.notice) {
        return this.$t("index.loading");
      }
      return data.notice;
    },
    getBasicConfig() {
      // 明确指定获取配置
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        if (res && res.data) {
          this.basicData = res.data;
          this.getNotice(this.basicData);
          this.getBanner(this.basicData);
        }
      });
    },
    getHotLottery() {
      this.$http({
        method: "get",
        url: "lottery_hot",
      }).then((res) => {
        console.log(res, 11);
      });
    },
    getBanner(data) {
      this.banners = Array.isArray(data.banners) ? data.banners : [];
    },
    toLogin(str) {
      this.$router.push({ path: str });
    },
    getNotice(data) {
      this.notice = this.getNoticeText(data);
    },
    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },
    checkToken() {
      const token = localStorage.getItem("token");
      this.hasToken = !!token;
    },
    getxuanfeilist() {
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { id: 1, page: 1 },
      }).then((res) => {
        const lanng = localStorage.getItem("lang");
        this.datalist = res.data;

        this.datalist.forEach(item => {
          const parts = item.flag.split("|");
          lanng == "zh"
            ? item.flag = parts[0]
            : lanng == "en"
            ? item.flag = parts[1]
            : lanng == "ja"
            ? item.flag = parts[2]
            : item.flag = parts[3];

          item.flagArray = item.flag.split("，");
        });

        const chunkSize = 2;
        this.groupedData = this.datalist.reduce((acc, item, index) => {
          if (index % chunkSize === 0) acc.push([]);
          acc[Math.floor(index / chunkSize)].push(item);
          return acc;
        }, []);
      });
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    shuffleArray(arr) {
      const newArr = [...arr];
      for (let i = newArr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
      }
      return newArr;
    },
    setRandomOnlineCount() {
      if (!this.onlineCount) {
        this.onlineCount = this.getRandomInt(5000, 200000);
        return;
      }
      const isIncrease = Math.random() > 0.5;
      const change = this.getRandomInt(500, 1000);
      if (isIncrease) {
        this.onlineCount += change;
      } else {
        this.onlineCount -= change;
      }
      if (this.onlineCount < 5000) this.onlineCount = 5000;
      if (this.onlineCount > 200000) this.onlineCount = 200000;
    },
    buildRollingList() {
  if (!poolData || !poolData.ja || !poolData.en) {
    return;
  }
  const jaNames = this.shuffleArray(poolData.ja.names);
  const jaCities = this.shuffleArray(poolData.ja.cities);
  const enNames = this.shuffleArray(poolData.en.names);
  const enCities = this.shuffleArray(poolData.en.cities);
  const list = [];
  const totalItems = 10;
  for(let i = 0; i < totalItems; i++) {
     if (i % 2 === 0) {
        list.push({ name: jaNames[i % jaNames.length], city: jaCities[i % jaCities.length] });
     } else {
        list.push({ name: enNames[i % enNames.length], city: enCities[i % enCities.length] });
     }
  }
  const finalPool = this.shuffleArray(list);
  const avatars = this.shuffleArray(this.avatarPool);
  this.displayRollingList = finalPool.map((item, index) => ({
    name: item.name,
    city: item.city,
    age: this.getRandomInt(25, 45),
    avatar: avatars[index % avatars.length]
  }));
},
    startOnlineMatchingAnimation() {
      this.$nextTick(() => {
        const rowHeight = Math.round(window.innerWidth * 0.145);
        if (this.scrollTimer) clearInterval(this.scrollTimer);
        let currentIndex = 0;
        this.scrollTimer = setInterval(() => {
          currentIndex += 1;
          this.onlineTranslateY = -(currentIndex * rowHeight);
          if (currentIndex >= this.displayRollingList.length) {
            setTimeout(() => {
              this.onlineTranslateY = 0;
              currentIndex = 0;
              this.buildRollingList();
              this.setRandomOnlineCount();
            }, 500);
          }
        }, 2400);
      });
    }
  },
  mounted() {
    this.buildRollingList();
    this.setRandomOnlineCount();
    this.startOnlineMatchingAnimation();
  },
  beforeDestroy() {
    if (this.scrollTimer) clearInterval(this.scrollTimer);
  },
  created() {
    this.checkToken();
    this.getBasicConfig();
    this.getxuanfeilist();
    this.getHotLottery();
  },
};
</script>

<style lang="less" scoped>
.header {
  height: 13vw;
  background: linear-gradient(30deg, #7d76ef, #d63f8c);
}
.header_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin: 0 40px;
  color: #fff;
  .img {
    height: 80px;
    display: flex;
    align-items: center;

    img {
      height: 100%;
      width: auto;
      display: block;
      object-fit: contain;
    }
  }
}
.notice-swiper {
  height: 11vw;
  font-size: 4vw;
  border-radius: 7vw;
}
.sub {
  background: rgb(63, 58, 91);
  padding: 8px;
  color: rgb(235, 202, 175);
  font-size: 24px;
  border-radius: 16px 0;
  margin-left: 4px;
}
.gdgride {
  padding-right: 40px;
}
.gdgride div {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}
.van-image {
  position: relative;
  display: inline-block;
}

.online-match-box {
  width: 96%;
  margin: 3vw auto 5vw;
  padding: 2.8vw 2.6vw 3.2vw;
  border-radius: 4vw;
  box-sizing: border-box;
  overflow: hidden;
  background:
    radial-gradient(circle at top left, rgba(255,255,255,0.18), transparent 34%),
    radial-gradient(circle at bottom right, rgba(255,255,255,0.12), transparent 30%),
    linear-gradient(135deg, #ff5f89 0%, #ff7b9f 48%, #ff91ab 100%);
  box-shadow: 0 2vw 4vw rgba(232, 86, 130, 0.16);
}

.online-match-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.4vw;
  color: #fff27d;
  text-align: center;
  padding: 0.2vw 0 2.4vw;
  font-size: 4.1vw;
  font-weight: 700;
  letter-spacing: 0.2vw;
  text-shadow: 0 0.2vw 0.6vw rgba(0,0,0,0.08);
}

.online-dot {
  width: 1.8vw;
  height: 1.8vw;
  border-radius: 50%;
  background: #7cff9d;
  box-shadow: 0 0 1.8vw rgba(124,255,157,0.9);
  flex-shrink: 0;
}

.OnlineMatching {
  height: 29vw;
  overflow: hidden;
}

.online-scroll {
  transition: transform 0.55s ease-in-out;
}

.online-row {
  height: 14.5vw;
  display: flex;
  align-items: center;
  padding: 2vw 2.2vw;
  margin-bottom: 1vw;
  border-radius: 3.2vw;
  box-sizing: border-box;
  background: linear-gradient(90deg, rgba(255,255,255,0.18), rgba(255,255,255,0.10));
  border: 1px solid rgba(255,255,255,0.18);
  backdrop-filter: blur(2px);
}

.online-avatar-wrap {
  position: relative;
  flex-shrink: 0;
  margin-right: 2.2vw;
}

.online-avatar {
  width: 9vw;
  height: 9vw;
  border-radius: 50%;
  object-fit: cover;
  background: #fff;
  border: 0.5vw solid rgba(255,255,255,0.95);
  box-shadow: 0 0.8vw 1.8vw rgba(0,0,0,0.12);
}

.online-badge {
  position: absolute;
  right: -0.8vw;
  bottom: -0.4vw;
  padding: 0.2vw 1vw;
  border-radius: 2vw;
  background: linear-gradient(90deg, #7a4cff, #c93cff);
  color: #fff;
  font-size: 2vw;
  line-height: 1.5;
  border: 1px solid rgba(255,255,255,0.75);
}

.online-inline {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 1.6vw;
  white-space: nowrap;
  overflow: hidden;
}

.online-name {
  color: #fff;
  font-size: 3.8vw;
  font-weight: 700;
  flex-shrink: 0;
}

.online-meta {
  color: rgba(255,255,255,0.96);
  font-size: 3.15vw;
  flex-shrink: 0;
}

.online-status {
  min-width: 0;
  color: #fff;
  font-size: 3.15vw;
  opacity: 0.98;
  overflow: hidden;
  text-overflow: ellipsis;
}

.online-live {
  margin-left: 1.8vw;
  padding: 0.5vw 1.6vw;
  border-radius: 999px;
  background: rgba(255,255,255,0.18);
  color: #fff;
  font-size: 2.6vw;
  font-weight: 700;
  letter-spacing: 0.08vw;
  flex-shrink: 0;
  border: 1px solid rgba(255,255,255,0.22);
}

.horizontalItem {
  display: flex;
  border-bottom: 2px solid #eee;
  padding: 40px 0 4vw;
}
.horizontalItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  margin-right: 40px;
}
.top {
  display: flex;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div :nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div :nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .tags {
  display: flex;
  margin: 10px 0 10px;
  flex-wrap: wrap;
}
.horizontalItem .tags .van-tag {
  padding: 15px;
  font-size: 3vw;
  margin: 0 10px 10px 0;
  border-radius: 16px;
}
.horizontalItem .yueta {
  background: linear-gradient(90deg, #df35ad, #4f1db5);
  color: #fff;
  border-radius: 16px;
  padding: 20px 0;
  text-align: center;
  font-size: 3vw;
}
</style>